import React from 'react';

const ListScreenKeys = ({ documentData }) => {
  const record = documentData;
  return [
    {
      label: 'Attachments',
      value: record?.attachments?.length ? record?.attachments?.map((item, index) => (
        <div key={item?.url}>
          <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
        </div>
      )) : '-',
    },
  ];
};

export default ListScreenKeys;
